import { render } from "./RestartParser.vue?vue&type=template&id=2b241073&scoped=true"
import script from "./RestartParser.vue?vue&type=script&lang=js"
export * from "./RestartParser.vue?vue&type=script&lang=js"

import "./RestartParser.vue?vue&type=style&index=0&id=2b241073&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b241073"]])

export default __exports__